import { useResetLocalToRemoteCommand } from "commands/definitions/branch/useResetLocalToRemoteCommand";
import { useToggleBranchCreatorCommand } from "commands/definitions/branch/useToggleBranchCreatorCommand";
import { useToggleBranchPickerCommand } from "commands/definitions/branch/useToggleBranchPickerCommand";
import { useToggleRenamePaletteCommand } from "commands/definitions/branch/useToggleRenamePaletteCommand";
import { useRegisterCommands } from "components/Layout/Panels/VSCode/useRegisterCommands";
import { useBranchEditor } from "features/editor/Feature";
import { useCapabilities } from "hooks/pitcher/useCapabilities";
import { usePermissions } from "hooks/pitcher/usePermissions";

import { createRegistrator } from "commands/register";

import { useOpenPRCommand } from "../definitions/branch/useOpenPRCommand";

import { RegisterBranchCreatorCommands } from "./useRegisterBranchCreatorCommands";

const useRegisterBranchCommands = (): void => {
  const { branch } = useBranchEditor();

  const pitcherPermissions = usePermissions();
  const pitcherCapabilities = useCapabilities();

  const openPR = useOpenPRCommand();
  const toggleBranchPicker = useToggleBranchPickerCommand();
  const toggleBranchCreator = useToggleBranchCreatorCommand();
  const toggleBranchRename = useToggleRenamePaletteCommand();

  const resetLocalToRemote = useResetLocalToRemoteCommand({
    event_source: "command_palette",
  });

  useRegisterCommands([toggleBranchPicker], []);
  useRegisterCommands([toggleBranchCreator], []);
  useRegisterCommands(
    pitcherCapabilities.git?.pull && pitcherPermissions.git?.pull
      ? [resetLocalToRemote]
      : [],
    [],
  );

  useRegisterCommands(
    pitcherCapabilities.git?.renameBranch &&
      pitcherPermissions.git?.renameBranch
      ? [toggleBranchRename]
      : [],

    [branch],
  );

  useRegisterCommands(openPR ? [openPR] : [], []);
};

const _RegisterBranchCommands = createRegistrator(useRegisterBranchCommands);

export const RegisterBranchCommands = () => {
  return (
    <>
      <_RegisterBranchCommands />
      <RegisterBranchCreatorCommands />
    </>
  );
};
